<template>
  <section class="sec-cooperate">
    <div class="footer-title" />
    <div class="float-bg" />
    <div class="box-sizing-wrapper">
      <div class="box-sizing-main">
        <img :src="cooperateImg" alt="" />
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {}
  },
  props: {
    cooperateImg: {
      type: String,
      default: () => '',
    },
  },
  methods: {},
}
</script>
<style lang="less">
.sec-cooperate {
  position: relative;
  max-width: 1001px;
  margin: 0 auto;
  .footer-title {
    background-image: url('~@/assets/carnival2020/cooperate_title.png');
  }
  .float-bg {
    width: 317px;
    height: 129px;
    top: 15px;
    right: -149px;
  }
  .box-sizing-wrapper {
    margin-top: 10px;
    .box-sizing-main {
      background-color: #ffffff;
      img {
        width: 100%;
      }
    }
  }
}
</style>
